import { Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-general-button',
  imports: [TranslatePipe, MatIconModule, NgClass],
  templateUrl: './general-button.component.html',
  styleUrl: './general-button.component.scss',
})
export class GeneralButtonComponent {
  readonly buttonName = input.required<string>();
  readonly buttonHeight = input<24 | 32 | 40 | 48 | 56>(40);
  readonly buttonStyle = input.required<'primary' | 'secondary' | 'inline'>();
  readonly buttonAccentStyle = input<'danger' | 'warning' | 'info' | undefined>();
  readonly buttonType = input<'button' | 'submit' | 'reset'>('button');
  readonly iconStart = input<string>();
  readonly iconEnd = input<string>();
  readonly disabled = input<boolean>(false);

  readonly buttonClicked = output<MouseEvent>();

  protected readonly buttonClass = computed(() => {
    const main = this.buttonStyle();
    const accent = this.buttonAccentStyle() ? main + '--' + this.buttonAccentStyle() : '';
    return main + ' ' + accent;
  });
}
